import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule, NavController, NavParams, LoadingController, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserProvider } from "src/app/services/user/user";
import { CadastroBuscaControlePage } from "../cadastro-busca-controle/cadastro-busca-controle.page";
import { FormGeradorPage } from "../../form-gerador/form-gerador.page";
declare var instituicaoConstants: { INSTITUICAO: any; };

interface AutoCadastro {
  id: number;
  perguntaFrequentaInst: string;
  idInstituicaoExterior: number;
  idInstituicaoVisitante: number;
  informativoLocalizarUnidade: string;
  mensagemCadastroExistente: string;
  idInstituicao: number;
  nomeInstituicaoExterior: string;
  nomeInstituicaoVisitante: string;
};

@Component({
  selector: "app-auto-cadastro",
  templateUrl: "./auto-cadastro.html",
  styleUrls: ["./auto-cadastro.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
  ],
})
export class AutoCadastroPage {
  facebook: any = {};
  configAutoCadastro = {} as AutoCadastro;
  exibirPergunta: boolean;
  canNext = false;
  instituicaoSelecionada: any;
  home: string = "HomeCustomPage";
  findByGeolocalizacao = false;
  loadedPage = false;
  frequentaInstPergunta = null;
  localizacaoPergunta = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService,
  ) {
    this.getConfigAutoCadastro();
  }

  public getConfigAutoCadastro() {
    this.userProvider
      .getConfigAutoCadastro(instituicaoConstants.INSTITUICAO)
      .subscribe((data: { config: AutoCadastro; }) => {
        this.configAutoCadastro = data.config;
        this.loadedPage = true;
      });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async selecionar() {
    if (this.findByGeolocalizacao || this.localizacaoPergunta === "brasil") {
      this.openInstByGeoLocalizacao();
      return;
    }

    this.userProvider.idInstituicao = this.instituicaoSelecionada.id;

    const cadastro: any = {};
    cadastro.form = "APP_CAD_INICIO";
    cadastro.idPessoaTipo = 5;
    cadastro.titulo = this.translate.instant("Novo Cadastro");
    cadastro.idInstituicao = 6143;
    cadastro.facebook = this.facebook;

    const modalCadastro = await this.modalCtrl.create({
      component: FormGeradorPage,
      componentProps: cadastro
    });
    modalCadastro.present();

    const datas = await modalCadastro.onDidDismiss();
    if (datas.data) {
      this.modalCtrl.dismiss(datas.data);
    }
  }

  onFrequentaInstChange(event: any) {
    if (event.detail.value === '1') {
      this.exibirPergunta = true;
      this.canNext = false;
    } else {
      this.exibirPergunta = false;
      this.canNext = true;

      this.instituicaoSelecionada = {
        id: this.configAutoCadastro.idInstituicaoVisitante,
      };
    }
  }

  async openInstByGeoLocalizacao() {
    const modalCadastro = await this.modalCtrl.create({
      component: CadastroBuscaControlePage,
      componentProps: { informativoLocalizarUnidade: this.configAutoCadastro.informativoLocalizarUnidade }
    });
    modalCadastro.present();

    const datas = await modalCadastro.onDidDismiss();
    if (datas.data) {
      this.modalCtrl.dismiss(datas.data);
    }
  }

  onLocalizacaoChange(event: any) {
    if (event.detail.value === "exterior") {
      this.instituicaoSelecionada = {
        id: this.configAutoCadastro.idInstituicaoExterior,
      };

      this.findByGeolocalizacao = false;
    } else {
      this.findByGeolocalizacao = true;
    }

    this.canNext = true;
  }

  voltar() {
    this.modalCtrl.dismiss();
  }
}
